export const validateRevista = (value: any, allValues: any) => {
  if (allValues?.tipo === "edicao" && !value) {
    return "ra.validation.required";
  }
  return undefined;
};
